export enum routes {
    CART = '/checkout/cart',
    CONFIRM = '/checkout/confirm',
    ORDER = '/checkout/order',
    SUMMARY = '/checkout/summary',
}
